module.exports = __webpack_public_path__ + "img/icon1.89fb37ca.png";